import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WalletWithdrawState {
  withdrawBank: number;
  defaultBank: number;
  password: string;
  transferStatus: string;
  withdrawAmount: number;
}

const initialState: WalletWithdrawState = {
  withdrawBank: 0,
  defaultBank: 0,
  password: "",
  transferStatus: "not-verified",
  withdrawAmount: 400
};

const walletWithdrawSlice = createSlice({
  name: "walletWithdraw",
  initialState,
  reducers: {
    setWithdrawBank(state, action: PayloadAction<number>) {
      state.withdrawBank = action.payload;
    },
    setDefaultBank(state, action: PayloadAction<number>) {
      state.defaultBank = action.payload;
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    setwithdrawAmount(state, action: PayloadAction<number>) {
      state.withdrawAmount = action.payload;
    },
    confirmTransfer(state, action: PayloadAction<any>) {
      // Logic to initiate transfer confirmation
      state.transferStatus = "pending-confirmation";
    },
    verifyPassword(state, action: PayloadAction<string>) {
      if (action.payload === "correct-password") {
        state.transferStatus = "password-verified";
      } else {
        state.transferStatus = "password-error";
      }
    },
  },
});

export const { setWithdrawBank,confirmTransfer, setDefaultBank, setPassword, verifyPassword,setwithdrawAmount } =
  walletWithdrawSlice.actions;

export default walletWithdrawSlice.reducer;
